import { t as s } from "./isDefined-fMi6eQ4r.js";
import { isBoolean as o } from "@sniptt/guards";
var j = (_) => s(_) && !o(_) && _ !== "", r = "_root_sos59_1", a = "_solid_sos59_22", e = "_outline_sos59_26", v = "_soft_sos59_30", n = "_sm_sos59_35", t = "_md_sos59_40", i = "_square_sos59_46", c = "_round_sos59_51", k = "_accent_sos59_57", d = "_success_sos59_63", u = "_warning_sos59_69", l = "_hoverable_sos59_75", m = "_box_sos59_113", b = "_indicator_sos59_134", h = "_check_sos59_150", p = "_minus_sos59_151", z = {
  root: r,
  solid: a,
  outline: e,
  soft: v,
  sm: n,
  md: t,
  square: i,
  round: c,
  accent: k,
  success: d,
  warning: u,
  hoverable: l,
  box: m,
  indicator: b,
  check: h,
  minus: p
}, I = "_root_8kk9v_2", f = "_submenuIcon_8kk9v_51", x = "_startIcon_8kk9v_55", D = "_endIcon_8kk9v_56", g = "_label_8kk9v_72", q = "_text_8kk9v_82", w = "_description_8kk9v_90", y = "_inlineDescription_8kk9v_98", B = "_endDescription_8kk9v_103", C = "_hotkeys_8kk9v_108", L = "_actions_8kk9v_114", R = "_checkIndicator_8kk9v_131", A = {
  root: I,
  submenuIcon: f,
  startIcon: x,
  endIcon: D,
  label: g,
  text: q,
  description: w,
  inlineDescription: y,
  endDescription: B,
  hotkeys: C,
  actions: L,
  checkIndicator: R
};
export {
  z as n,
  j as r,
  A as t
};
